/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import CallToActionCard from 'common/components/cards/callToActionCard';
import GeneralTabs from 'common/components/navigation/actionsTab/tabs';
import {
  BUTTON_BACKGROUND_COLOR,
  BUTTON_TEXT_COLOR,
  COMPANY_COLORS,
} from 'config/consts';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getActionById,
  setDetail,
  subscribe,
  subscribeTanqueCheio,
  setSubscribed,
  setFeedbackModal,
  getLottieById,
} from './activitiesActions';
import moment from 'moment';
import MaterialModal from 'common/components/modal/materialModal';
import { BASE_S3 } from 'config/consts';
import { getUserPoints } from 'modules/user/pages/homepage/homepageActions';
import { makeStyles } from '@material-ui/core/styles';
import './activity.css';
import { isMobile } from 'react-device-detect';
import DOMPurify from 'dompurify';
import ReactPlayer from 'react-player';
import { Grid, Typography } from '@material-ui/core';
import { DomPurifyContentContainer } from './styles';
import { getVouchersUrl } from 'helpers/urls';
import { getDependents } from './activitiesActions';

const QRCode = require('qrcode.react');

const useStyles = makeStyles((theme) => ({
  paper: {
    maxHeight: isMobile ? '100vh' : '95vh',
  },
  reactPlayer: {
    backgroundColor: 'black',
    float: 'left',
  },
}));

function renderStart(props) {
  return (
    <Grid item container xs={12} justifyContent="center" alignItems="center">
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
        style={{
          marginBottom: '1.5rem',
        }}
      >
        <Typography variant="body1">
          <DomPurifyContentContainer
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.activities?.detail?.description || ''),
            }}
          />
        </Typography>
      </Grid>
      
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
      >
        {props.activities?.detail?.action_videos?.length > 0 ? (
          <Grid item container xs={12} justyfy="center" alignItems="center">
            <ReactPlayer
              width={'100%'}
              height={isMobile ? '17rem' : '30rem'}
              controls
              className="react-player"
              key={props.activities.detail.action_videos[0].video.url}
              url={props.activities.detail.action_videos[0].video.url}
            />
          </Grid>
        ) : null}
      </Grid>
      
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
      >
        <CallToActionCard
          public={props.public || false}
          website={props.website}
          history={props.history}
          auth={props.auth}
          activity={props.activities?.detail}
          onClick={
            props.callToActionLink
              ? () => props.history.push(props.callToActionLink)
              : (values) => subscribeToCourse(values, props)
          }
          {...props}
        />
      </Grid>
    </Grid>
  );
}

function renderRules(props) {
  const voucherInfo = props.activities?.detail?.voucher_info;
  let parsedVoucherInfo = {};
  
  try {
    parsedVoucherInfo = typeof voucherInfo === 'string' ? JSON.parse(voucherInfo) : voucherInfo || {};
  } catch (error) {
    console.error('Erro ao parsear voucher_info:', error);
  }

  return (
    <Grid item container alignItems="center" xs={12}>
      <Typography variant="body1">
        <DomPurifyContentContainer
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              parsedVoucherInfo.voucher_regulation || 
              props.activities?.detail?.rules || 
              'Regulamento não disponível'
            ),
          }}
        />
      </Typography>
    </Grid>
  );
}

function subscribeToCourse(values, props) {
  // Usar endpoint específico para Tanque Cheio
  const actionData = {
    action_id: props.activities?.detail?.id,
    ...values,
  };
  props.subscribeTanqueCheio(actionData, props.auth.user.id);
}

function ActivityTanqueCheio(props) {
  const classes = useStyles();

  useEffect(() => {
    if (props.activities?.detail?.feedback_lottie_id) {
      props.getLottieById(props.activities.detail.feedback_lottie_id);
    }
    return () => {
      props.setSubscribed(false);
    };
  }, []);

  useEffect(() => {
    if (props.activities?.detail?.familiarVoucher === true) {
      props.getDependents(props.auth.user.cpf);
    }
  }, []);

  const dependenteArray = Array.isArray(props.dependentes)
    ? props.dependentes
    : props.dependentes ? [props.dependentes] : [];
    
  const showDependentes =
    props?.activities?.detail?.familiarVoucher &&
    Array.isArray(dependenteArray) &&
    dependenteArray.length > 0;

  return (
    <>
      <Grid item container xs={12} justifyContent="center" alignItems="center">
        <GeneralTabs
          start={renderStart(props)}
          rules={renderRules(props)}
          hiddenTabs={false}
        />
      </Grid>

      <MaterialModal
        showTitle
        PaperProps={{ classes: { root: classes.paper } }}
        open={props.activities?.subscribed}
        onClose={() => props.setSubscribed(false)}
        fullScreen={isMobile ? true : false}
      >
        <div
          className="container-fluid d-flex-column justify-content-space-around h-100"
          style={{ backgroundColor: 'transparent' }}
        >
          <div className="row justify-content-center mt-5">
            <div className="col-8 col-md-4">
              <img
                src={`${BASE_S3}/${COMPANY_COLORS.homepage.sidebar.logo}`}
                alt="LOGO-EMPRESA"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </div>
          </div>
          
          <div className="row justify-content-center mt-5">
            <div className="col-auto text-center">
              <Typography variant="h4">
                {props.activities?.detail?.name || 'Atividade Tanque Cheio'}
              </Typography>
            </div>
          </div>
          
          <div className="row justify-content-center mt-1">
            <div className="col-auto text-center">
              <Typography variant="body2">{props.auth?.user?.name}</Typography>
            </div>
          </div>
          
          {showDependentes && (
            <div className="row justify-content-center mt-1">
              <div className="col-auto text-center">
                <Typography variant="body1">Dependentes:</Typography>
                <Typography variant="body2">
                  {dependenteArray
                    .map(
                      (dependente, index) =>
                        `${dependente.dependente} (${dependente.parentesco})`
                    )
                    .join(', ')}
                </Typography>
              </div>
            </div>
          )}
          
          <div className="row justify-content-center mt-3">
            <div className="col-md-8 col-11">
              <h6 className="text-muted text-center">{`Voucher gerado em: ${moment(
                props.activities?.createdAt
              ).format('LLLL')}`}</h6>
            </div>
          </div>
          
          <div className="row justify-content-center mt-4">
            <div className="col-auto">
              <QRCode
                value={getVouchersUrl(
                  props.activities?.detail,
                  props.activities?.code
                )}
              />
            </div>
          </div>
          
          <div className="row justify-content-center mt-3">
            <div className="col-auto">
              <h5 className="text-muted">{props.activities?.code}</h5>
            </div>
          </div>
          
          {props.activities?.detail?.rules && (
            <div className="row justify-content-center mt-4">
              <div className="col-md-auto col-11">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.activities.detail.rules),
                  }}
                ></div>
              </div>
            </div>
          )}
          
          <div className="row justify-content-center mt-3">
            <div className="col-md-auto col-11">
              <h6 className="text-muted mb-0 text-center">
                Este voucher deverá ser utilizado até:
              </h6>
            </div>
          </div>
          
          <div className="row justify-content-center mt-0">
            <div className="col-md-auto col-11">
              <h6 className="text-muted text-center">
                {moment(props.activities?.detail?.end).format('LLLL')}
              </h6>
            </div>
          </div>
          
          <div className="row justify-content-center mt-5">
            <div className="col-md-auto col-11">
              <div
                className={'py-3 station-font-medium'}
                style={{
                  background: BUTTON_BACKGROUND_COLOR,
                  color: BUTTON_TEXT_COLOR,
                  borderRadius: 8,
                  paddingLeft: isMobile ? 40 : 140,
                  paddingRight: isMobile ? 40 : 140,
                  cursor: 'pointer',
                  fontSize: '1rem',
                  textAlign: 'center',
                }}
                onClick={() => window.print()}
              >
                {isMobile ? 'Salvar' : 'Imprimir'}
              </div>
            </div>
          </div>
          
          <div className="row justify-content-center mt-2 mb-5">
            <div className="col-auto">
              <button
                onClick={(event) => {
                  event.preventDefault();
                  props.setSubscribed(false);
                  window.open('#/homepage', '_self');
                }}
                style={{ textDecoration: 'underline', color: '#505050' }}
              >
                Página inicial
              </button>
            </div>
          </div>
        </div>
      </MaterialModal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    activities: state.activities,
    dependentes: state.activities?.dependents?.content,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getActionById,
      setDetail,
      subscribe,
      subscribeTanqueCheio,
      setSubscribed,
      setFeedbackModal,
      getLottieById,
      getUserPoints,
      getDependents,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityTanqueCheio);
